import api from './api';

export interface Nesting {
  id: string;
  code: string;
  machineId: string;
  status: 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | 'ERROR';
  startedAt: string;
  completedAt?: string;
  totalParts: number;
  partsCompleted: number;
  material?: string;
  thickness?: number;
  sheetLength?: number;
  sheetWidth?: number;
  nestingImagePath?: string;
  parts?: Part[];
  machine?: { id: string; name: string };
}

export interface Part {
  id: string;
  code: string;
  nestingId: string;
  sequenceNumber?: number;
  status: 'IN_PROGRESS' | 'COMPLETED' | 'ERROR';
  startedAt: string;
  completedAt?: string;
  totalPaths: number;
  pathsCompleted: number;
  paths?: Path[];
}

export interface Path {
  id: string;
  code: string;
  partId: string;
  sequenceNumber?: number;
  status: 'IN_PROGRESS' | 'COMPLETED' | 'ERROR';
  startedAt: string;
  completedAt?: string;
  laserPower?: number;
  feedRate?: number;
  pathType?: string;
}

export const productionService = {
  getNestings: async (params?: {
    machineId?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<{ nestings: Nesting[]; pagination: any }> => {
    const queryParams = new URLSearchParams();
    if (params?.machineId) queryParams.append('machineId', params.machineId);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);

    const response = await api.get(`/production/nestings?${queryParams}`);
    return response.data?.data || { nestings: [], pagination: {} };
  },

  getNesting: async (id: string): Promise<Nesting> => {
    const response = await api.get(`/production/nestings/${id}`);
    return response.data?.data?.nesting;
  },
};
